import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { RouterModule } from '@angular/router';
import { NewsListComponent } from './news-list/news-list.component';
import { SharedModule } from '../../components/shared/shared.module';
import { UiModule } from '../ui/ui.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiModule
    ],
    providers: [],
    declarations: [
        NewsDetailComponent,
        NewsListComponent
    ],
    exports: [
        NewsListComponent
    ]
})
export class NewsModule { }
